import { useCallback } from 'react';
import { usePostHog } from 'posthog-js/react';

import { selectUser } from '../store/auth.slice';

import { useAppSelector } from './redux';

export type PosthogEventProperties = Record<string, unknown>;

export const usePosthogCapture = () => {
  const posthog = usePostHog();
  const user = useAppSelector(selectUser);

  return useCallback(
    (eventName: string, properties: PosthogEventProperties = {}) => {
      if (!posthog || !user?.id) {
        return;
      }

      posthog.capture(eventName, {
        user_id: user.id,
        ...properties,
      });
    },
    [posthog, user?.id],
  );
};
